module.exports = __webpack_public_path__ + "static/media/Past-sessions.e1bdb390.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/HamburgerIcons/Past-sessions.svg
// module id = 571
// module chunks = 1